import { Task } from '@griply/types';
import { DeletedFilter } from '@griply/utils';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';
import { TaskType } from 'shared/types/task-base';

// The one base subscription per task type — type only, no server narrowing, so
// TanStack dedupes every flag variant onto a single Firestore listener. Never
// inline `{ type: TaskType.X }` into `useTasksQuery` elsewhere; go through here.
export const useAllTasksOfType = (
  type: TaskType,
  deletedFilter: DeletedFilter = DeletedFilter.ExcludeDeleted,
): Task[] => {
  const user = useUser();
  const { data } = useTasksQuery(user?.uid, { type }, true, { deletedFilter });

  return data ?? [];
};
